module.exports = __webpack_public_path__ + "fonts/Comfortaa-SemiBold.d905de65.ttf";